var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivitySvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.398438,
    width: 27,
    height: 27,
    rx: 5,
    fill: "#00BA07"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.167 10.2318L12.0003 11.3984L14.167 13.5651H5.66699V15.2318H14.167L12.0003 17.3984L13.167 18.5651L17.3337 14.3984L13.167 10.2318ZM20.667 20.2318H14.0003V21.8984H20.667C21.5837 21.8984 22.3337 21.1484 22.3337 20.2318V8.5651C22.3337 7.64844 21.5837 6.89844 20.667 6.89844H14.0003V8.5651H20.667V20.2318Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitySvg);
export default __webpack_public_path__ + "static/media/activitySVG.f646efddffadb77bee6726bd3b2ca310.svg";
export { ForwardRef as ReactComponent };